__turbopack_context__.v({
  "divider": "-xSBha_divider",
  "footer": "-xSBha_footer",
  "heading": "-xSBha_heading",
  "link": "-xSBha_link",
  "main": "-xSBha_main",
  "navBlock": "-xSBha_navBlock",
  "navigationDesktop": "-xSBha_navigationDesktop",
  "navigationMobile": "-xSBha_navigationMobile",
  "newsletterWrapper": "-xSBha_newsletterWrapper",
});
